module.exports = __webpack_public_path__ + "static/media/addrow.b2641497.svg";